(function () {
    'use strict';
    angular.module('GorillaBoy.services')
    .factory('PreferencesService', [
        'UserService',
        'authenticatedUser',
        '$q',
        PreferencesService
    ]);

    function PreferencesService (UserService, authenticatedUser, $q) {
        var prefService = {},
            userPreferences = {},
            TRUE_STRING = 'TRUE',
            FALSE_STRING = 'FALSE';

        prefService.init  = function() {
            var userInfo, preferences, pref;
            userInfo = authenticatedUser.getUserInfo();

            return $q.when(userPreferences);
        };

        prefService.getPreference = function (key) {
            if (userPreferences && userPreferences[key]) {
                if (userPreferences[key] === TRUE_STRING) {
                    return true;
                } else {
                    return false;
                }
            }
            return false;
        };

        prefService.setPreference = function (key, value) {
            if (value) {
                userPreferences[key] = TRUE_STRING;
            } else {
                userPreferences[key] = FALSE_STRING;
            }

            UserService.changePreferences(authenticatedUser.getUserInfo().Id, userPreferences);
        };

        return prefService;
    }
}());
